// ============================================================================
//  ComingSoon — reusable Nexus-themed "under construction" placeholder.
//  Used anywhere a feature has been temporarily shelved on the UI while the
//  backend / data stays intact (BReels, Elysium Wear, etc.).
// ============================================================================
import React from "react";
import { Sparkles } from "lucide-react";

export default function ComingSoon({
  title = "Coming soon",
  subtitle = "This chapter of NEXUS is still being wired up.",
  accent = "cyan",            // cyan | violet | amber | mint
  compact = false,
  icon: Icon = Sparkles,
  testId = "coming-soon",
}) {
  const accentMap = {
    cyan:   { text: "text-nexus-cyan",   ring: "ring-nexus-cyan/30",   dot: "bg-nexus-cyan",   glow: "shadow-[0_0_60px_-20px_rgba(34,211,238,0.6)]" },
    violet: { text: "text-nexus-violet", ring: "ring-nexus-violet/30", dot: "bg-nexus-violet", glow: "shadow-[0_0_60px_-20px_rgba(167,139,250,0.6)]" },
    amber:  { text: "text-nexus-amber",  ring: "ring-nexus-amber/30",  dot: "bg-nexus-amber",  glow: "shadow-[0_0_60px_-20px_rgba(251,191,36,0.6)]" },
    mint:   { text: "text-nexus-mint",   ring: "ring-nexus-mint/30",   dot: "bg-nexus-mint",   glow: "shadow-[0_0_60px_-20px_rgba(74,222,128,0.6)]" },
  };
  const a = accentMap[accent] || accentMap.cyan;

  return (
    <div
      className={`relative overflow-hidden rounded-2xl bg-nexus-surface ring-1 ${a.ring} ${a.glow} ${compact ? "p-5" : "p-10 md:p-14"} text-center`}
      data-testid={testId}
    >
      {/* grid backdrop */}
      <div
        className="absolute inset-0 opacity-[0.08] pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(to right, currentColor 1px, transparent 1px), linear-gradient(to bottom, currentColor 1px, transparent 1px)",
          backgroundSize: "32px 32px",
        }}
      />
      <div className="relative flex flex-col items-center">
        <div className={`flex items-center gap-2 text-[9px] tracking-[0.35em] uppercase ${a.text}`}>
          <span className={`inline-block w-1.5 h-1.5 rounded-full ${a.dot} animate-pulse`} />
          // coming soon
          <span className={`inline-block w-1.5 h-1.5 rounded-full ${a.dot} animate-pulse`} />
        </div>
        <div className={`mt-4 inline-flex items-center justify-center w-12 h-12 rounded-full bg-black/40 ring-1 ${a.ring}`}>
          <Icon className={`w-5 h-5 ${a.text}`} />
        </div>
        <h3 className={`mt-4 font-display font-black tracking-tight ${compact ? "text-xl" : "text-3xl md:text-4xl"} text-white`}>
          {title}
        </h3>
        <p className={`mt-2 max-w-md text-white/60 ${compact ? "text-xs" : "text-sm"} leading-relaxed`}>
          {subtitle}
        </p>
        <div className={`mt-5 h-px w-24 ${a.dot} opacity-40`} />
        <div className="mt-3 font-mono text-[10px] tracking-[0.3em] uppercase text-white/30">
          nexus.v3 · chapter loading
        </div>
      </div>
    </div>
  );
}
